
  import { computed, defineComponent, ref } from 'vue';
  import {
    $callDuration,
    $currentActiveCallId,
    $lastCallNumber,
    CALL_STATUSES,
    createCall,
    currentSelectCall,
    setSelectCall,
  } from '@/store/calls';
  import { useStore } from 'effector-vue/composition';
  import { Button, Hint, Icon, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import { timeFormat } from '@/lib/Helpers';
  import { $settings } from '@/store/settings';

  export default defineComponent({
    name: 'CallEnded',
    components: {
      Icon,
      Typography,
      Button,
      Hint,
    },
    setup() {
      const { t } = useI18n();
      const selectCall = useStore(currentSelectCall);
      const callDuration = useStore($callDuration);
      const settingsState = useStore($settings);
      const currentActiveCallId = useStore($currentActiveCallId);
      const lastCallNumber = useStore($lastCallNumber);
      const closeSelectCall = () => {
        setSelectCall(currentActiveCallId.value || ''); // open active call or open dialing view
      };
      const callTime = ref(
        selectCall.value && callDuration.value[selectCall.value?.id]
          ? timeFormat(callDuration.value[selectCall.value?.id]?.callDuration)
          : '' // call failed
      );
      const redialCall = () => {
        createCall({
          number: lastCallNumber.value.number,
          video: lastCallNumber.value.isVideo,
        });
      };
      const errorText = computed(() => {
        if (selectCall.value && CALL_STATUSES.includes(selectCall.value?.status)) {
          return settingsState.value.minimize
            ? selectCall.value?.status + ' • ' + t(`errors.${selectCall.value?.status}`)
            : t(`errors.${selectCall.value?.status}`);
        } else {
          return selectCall.value?.status;
        }
      });
      const showError = computed(
        () => selectCall.value?.status !== 'ENDED' && errorText.value !== 'CONNECTED'
      );

      return {
        t,
        redialCall,
        selectCall,
        closeSelectCall,
        callDuration,
        timeFormat,
        callTime,
        settingsState,
        errorText,
        showError,
      };
    },
  });
